export default {
  covenant: {
    type: Object,
    require: true
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/index/components/resources/props.js